import type { UserRole } from "@/lib/api";

/**
 * デバイスの管理と、環境をデバイスで動かす操作 (作成画面の実行場所) の表示可否。backend の RunnerAccess.ManagerRoles と揃え、
 * 組織の管理者 (Admin・SuperAdmin) だけ。
 */
export function canSeeRunnerManagement(
	role: UserRole,
	deviceManagementAvailable: boolean,
): boolean {
	return deviceManagementAvailable && (role === "Admin" || role === "SuperAdmin");
}
